import type { ReactNode } from 'react';
import { POSITION_STATUS_LABELS, type PositionStatus } from '@nest-recruit/shared';
import { ARCHIVED_TONE, POSITION_STATUS_TONES } from '../../../components/status-tones';
import { ToneChip } from '../../../components/Tone';

/**
 * One status, one colour, everywhere. 06-qol §11: status colours are consistent
 * system-wide and never repurposed.
 *
 * An archived seat says so instead of showing its status. Archiving is orthogonal
 * to status — the row keeps whatever it held, so a historical report can still say
 * what it was doing when it was retired — but on a live ledger "vacant" on a seat
 * nobody will ever fill again is a lie of omission.
 */

export interface PositionStatusChipProps {
  readonly position: {
    readonly status: PositionStatus;
    readonly archivedAt: string | null;
  };
}

export function PositionStatusChip({ position }: PositionStatusChipProps): ReactNode {
  if (position.archivedAt !== null) {
    return (
      <ToneChip tone={ARCHIVED_TONE}>Archived</ToneChip>
    );
  }

  return (
    <ToneChip tone={POSITION_STATUS_TONES[position.status]}>
      {POSITION_STATUS_LABELS[position.status]}
    </ToneChip>
  );
}
